import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import FirstWeekRules from 'owa-service/lib/contract/FirstWeekRules';

/**
 * Gets the fallback value for first week of the year
 */
export default () =>
    getFallbackValueIfNull(store().firstWeekOfYear, getCalendarConfiguration().FirstWeekOfYear);

export { FirstWeekRules };
